import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// v0.17.0 — InSite SaaS suite design tokens. MUST load before index.css
// so any legacy styles in index.css can be progressively migrated to
// var() refs without a CSS-cascade fight.
import './styles/tokens.css';
import './index.css';
// v0.55.0 — responsive / mobile layer (loads last so its media queries
// win the cascade). Makes the authenticated shell + pages reflow to a
// single column on a phone with no horizontal overflow.
import './styles/responsive.css';
import { initColorMode } from './colorMode.js';
initColorMode();
// v0.48.0 - the v0.46.2 X-InSite-User-Id fetch interceptor is GONE.
// Auth now rides an httpOnly InSite-ID session cookie that the browser
// attaches to same-origin /api/* requests itself - nothing to patch,
// nothing for an attacker to spoof.
// v0.17.2 — PWA: register the service worker + beforeinstallprompt hook.
import { registerSW } from './pwa.js';
// v0.177.0 — site mode holds a day's photos on the device, and that storage is
// evictable by default (iOS clears it after ~7 days unused, any browser may
// under pressure). Ask the browser to keep it. See utils/persistStorage.js.
import { requestPersistentStorage } from './utils/persistStorage.js';
// v0.x — Capacitor native shell (store build). On the WEB this whole call is
// a no-op (no window.Capacitor). In the wrapped app it must run BEFORE the
// router mounts: it installs the '/api' → live-host fetch rewrite that
// carries the Authorization bearer session (see src/utils/nativeShell.js).
import { initNativeShell } from './utils/nativeShell.js';
import { STORE_BUILD } from './utils/preview.js';
import { startBootSplash } from './utils/bootSplash.js';
initNativeShell();
// v0.319.0 — a file dropped on nothing never opens in place of DropPin.
import { installStrayDropGuard } from './utils/strayDropGuard.js';
installStrayDropGuard();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// v0.84.0 — retire the instant boot splash (index.html) once React has
// painted its first frame, fading into whatever the app shows (the SSO
// splash, the login screen, or the app). If the bundle never loads this never
// runs and the splash simply keeps spinning — still better than a blank page.
// v0.286.0 — except a client's report link, where the splash is held until the
// report is ready (src/utils/bootSplash.js).
startBootSplash();

// Kick off the SW registration AFTER React has mounted so the install
// prompt doesn't race the first paint.
registerSW();
// Fire and forget: a refusal is a fact the sync strip reports, never an error.
requestPersistentStorage();

// v0.207.4 — PICK UP THE FLOOR-SCAN CLIPS THE DEVICE IS STILL CARRYING.
//
// Brett: "if the screen does close will it start uploading again when the
// screen opens again". Yes, and by itself — a clip is kept in IndexedDB from
// the moment it is picked until storage confirms it, so an app closed mid-
// upload has the bytes on the next visit and does not have to send him back to
// a camera roll that shows no filenames.
//
// AFTER the first paint, deliberately: a 300 MB read must not sit in front of
// the login screen. And the API's own resume rule (v0.207.3) means a clip that
// already has a row continues on THAT row, so this cannot make duplicates.
// v0.249.0 — never in the App Store build, which has no floor scan.
if (!STORE_BUILD) setTimeout(() => {
  import('./utils/scanVideoQueue.js')
    .then((m) => m.scanVideoQueue().resume())
    .then((n) => { if (n) console.info(`[scan-video] resumed ${n} unfinished clip(s)`); })
    .catch(() => { /* no IndexedDB, or nothing waiting — neither is an error */ });
}, 2000);
